'use client'

import { TRACKER_EVENTS } from '@paladise/tracker/constants/event'
import { useSendTracker } from '@paladise/tracker/hooks/useSendTracker'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@paladise/ui/components/ui/alert-dialog'
import { cn } from '@paladise/ui/lib/utils'
import { chain } from '@paladise/utils/chain'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { isIOS } from 'react-device-detect'
import { isEmbed } from 'store/server-context/static'

interface IPaymentFailureDialogProps {
  isOpen: boolean
  onAction?: () => void
  onCloseAction?: () => void
  onClose: () => void
}

const PaymentFailureDialog = ({
  isOpen,
  onAction,
  onCloseAction,
  onClose,
}: IPaymentFailureDialogProps) => {
  const t = useTranslations()
  const { handleEventTracker } = useSendTracker()

  useEffect(() => {
    if (!isOpen) return
    handleEventTracker({
      eventName: TRACKER_EVENTS.popup_paymentfailure_show,
    })
  }, [])

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent
        position={isEmbed ? 'bottom' : 'center'}
        className={cn(isEmbed && isIOS && 'pb-[50px]', isEmbed && 'w-full')}
      >
        <AlertDialogHeader className={isEmbed ? 'text-left' : ''}>
          <AlertDialogTitle className={isEmbed ? 'text-header text-left' : ''}>
            {t('payment_failure')}
          </AlertDialogTitle>
          <AlertDialogDescription className={isEmbed ? 'text-body' : ''}>
            {t('payment_failure_description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            variant="primary"
            data-tracker-click={TRACKER_EVENTS.btn_editpayment_click}
            className={isEmbed ? 'h-[40px] py-[11px]' : 'p-[15px]'}
            onClick={chain(onAction, onClose)}
          >
            {t('edit_payment')}
          </AlertDialogAction>
          <AlertDialogCancel
            variant="secondary"
            data-tracker-click={TRACKER_EVENTS.btn_later_click}
            className={isEmbed ? 'h-[40px] py-[11px]' : 'p-[15px]'}
            onClick={chain(onCloseAction, onClose)}
          >
            {t('later')}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default PaymentFailureDialog
